<div class="mobile-content-wrapper">
  <div class="container pt-lg-4 pt-3">
    <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
  </div>
</div>
